import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { changePassword } from "../services/changePassword";
import SpinnerOverlay from "../Components/SpinnerOverlay";
import { LuSave } from "react-icons/lu";

export default function ChangePassword() {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            setError("");
            if (!token) {
                setError("El enlace no es válido.");
                return;
            }
            if (password.length < 8) {
                setError("La contraseña debe tener al menos 8 caracteres.");
                return;
            }
            if (password !== confirmPassword) {
                setError("Las contraseñas no coinciden.");
                return;
            }

            setLoading(true);
            const response = await changePassword(password, token);
            if (response?.success) {
                navigate("/login");
                return;
            }
            setError("No se pudo cambiar la contraseña.");
        } catch (error) {
            setError("No se pudo cambiar la contraseña, intentelo más tarde.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-shell relative min-h-screen overflow-hidden bg-zinc-950 text-white">
            <div
                className="pointer-events-none absolute inset-0 opacity-70"
                aria-hidden="true"
                style={{
                    background:
                        "radial-gradient(circle at 15% 20%, rgba(255, 74, 110, 0.20), transparent 34%), radial-gradient(circle at 85% 15%, rgba(59, 130, 246, 0.14), transparent 28%), radial-gradient(circle at 50% 85%, rgba(250, 204, 21, 0.08), transparent 36%)",
                }}
            />
            <SpinnerOverlay isLoading={loading} />
            <div className="relative mx-auto flex min-h-screen max-w-6xl items-center justify-center px-4 pb-12 pt-24">
                <section className="w-full max-w-md rounded-3xl border border-zinc-800 bg-zinc-900/65 p-8 shadow-[0_0_0_1px_rgba(255,255,255,0.02),0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-sm">
                    <h1 className="text-3xl font-bold text-white">Nueva contraseña</h1>
                    <p className="mt-2 text-sm text-zinc-300">
                        Ingresá una contraseña segura para tu cuenta.
                    </p>

                    <form className="mt-7 space-y-5" onSubmit={handleSubmit}>
                        <div>
                            <label
                                htmlFor="password"
                                className="mb-1 block text-sm font-medium text-zinc-300"
                            >
                                Nueva contraseña
                            </label>
                            <input
                                className="block w-full rounded-xl border border-zinc-700 bg-zinc-900 px-3 py-2.5 text-white outline-none transition focus:border-rose-500/70"
                                type="password"
                                name="password"
                                id="password"
                                value={password}
                                placeholder="Contraseña"
                                onChange={(e) => setPassword(e.target.value)}
                                minLength={8}
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="confirmpassword"
                                className="mb-1 block text-sm font-medium text-zinc-300"
                            >
                                Repetir contraseña
                            </label>
                            <input
                                className="block w-full rounded-xl border border-zinc-700 bg-zinc-900 px-3 py-2.5 text-white outline-none transition focus:border-rose-500/70"
                                type="password"
                                name="confirmpassword"
                                id="confirmpassword"
                                value={confirmPassword}
                                placeholder="Repetir contraseña"
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                minLength={8}
                            />
                        </div>

                        {error && (
                            <p className="rounded-xl border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300">
                                {error}
                            </p>
                        )}

                        <button className="w-full rounded-xl bg-gradient-to-r from-rose-500 to-rose-600 px-5 py-3 font-medium text-white shadow-[0_10px_20px_rgba(244,63,94,0.25)] transition-transform hover:scale-[1.01] disabled:cursor-not-allowed disabled:opacity-60" disabled={loading}>
                            <span className="inline-flex items-center gap-2">
                                <LuSave className="text-lg" />
                                {loading
                                    ? "Guardando..."
                                    : "Guardar nueva contraseña"}
                            </span>
                        </button>
                    </form>

                    <div className="mt-6 text-sm">
                        <Link
                            to="/login"
                            className="text-zinc-300 transition-colors hover:text-white"
                        >
                            Volver a iniciar sesión
                        </Link>
                    </div>
                </section>
            </div>
        </div>
    );
}
